import * as React from 'react'
import { observer } from 'mobx-react'
import { PrintingStore } from './PrintingStore'
import { Label, ProductLabel } from './ProductLabel'

export interface PrintViewProps {
  printingStore: PrintingStore
}

@observer
export default class PrintView extends React.Component<PrintViewProps, {}> {
  render() {
    const store = this.props.printingStore
    const locationId = store.locationId

    return (
      <div id='print-view' className='print-view'>
        <style
          dangerouslySetInnerHTML={{
            __html: `
              @media print {
                @page {
                  size: ${store.pageWidth}in ${store.pageHeight}in;
                  margin: 0;
                }
                .page {
                  margin: 0;
                  border: initial;
                  border-radius: initial;
                  width: initial;
                  min-height: initial;
                  box-shadow: initial;
                  background: initial;
                  page-break-after: always;
                }
              }
              body {
                margin: 0;
                padding: 0;
              }
              * {
                box-sizing: border-box;
                -moz-box-sizing: border-box;
              }
              .page {
                width: ${store.pageWidth}in;
                margin: 0;
                text-align: center;
              }
              .label {
                width: 100%;
                height: 100%;
              }
              .flex-fixed {
                flex-grow: 0;
                flex-shrink: 0;
              }
            `,
          }}
        />
        {store.layout === 'flat' ? (
          store.paginatedLabels.map((label, index) => (
            <div className='page' key={index}>
              <ProductLabel
                marginTop={store.marginTop}
                marginBottom={store.marginBottom}
                barcodeHeight={store.barcodeHeight}
                barcode={label.barcode}
                price={
                  label.overridePrices && locationId ? store.getRetailPrice(label) : label.price
                }
                useLegacyPrintingStyles={store.useLegacyPrintingStyles}
                shouldDisplayBarcode={store.displayBarcode}
                shouldDisplayBarcodeNumber={store.displayBarcodeNumber}
                shouldDisplayPrice={store.displayPrice}
                location={store.location}
                title={label.title || ''}
              />
            </div>
          ))
        ) : (
          <div
            className='page'
            style={{
              display: 'flex',
              flexWrap: 'wrap',
              padding: `${store.layout.topBottomMargin}in ${store.layout.leftRightMargin}in`,
            }}
          >
            {store.paginatedLabels.map((label, index) => (
              <div
                key={index}
                className='flex-fixed'
                style={{
                  width: `${store.labelWidth}in`,
                  height: `${store.labelHeight}in`,
                }}
              >
                <ProductLabel
                  marginTop={store.marginTop}
                  marginBottom={store.marginBottom}
                  barcodeHeight={store.barcodeHeight}
                  barcode={label.barcode}
                  price={
                    label.overridePrices && locationId ? store.getRetailPrice(label) : label.price
                  }
                  shouldDisplayBarcode={store.displayBarcode}
                  shouldDisplayBarcodeNumber={store.displayBarcodeNumber}
                  shouldDisplayPrice={store.displayPrice}
                  location={store.location}
                  useLegacyPrintingStyles={store.useLegacyPrintingStyles}
                  title={label.title || ''}
                />
              </div>
            ))}
          </div>
        )}
      </div>
    )
  }
}
